import {CATEGORY_GROUP_MAP, CATEGORY_ID, MYFC_CATEGORIES} from '@/constants';
import {CATEGORIES, CATEGORY_GROUP} from '@/enums';

export const getCategoriesGroup = (category: string) => {
  const groupList = Object.entries(CATEGORY_GROUP_MAP).map(
    ([categoryGroup, value]) => ({
      categoryGroup,
      category: value.join(','),
    })
  );

  return groupList.find((group) => group.category.includes(category))
    ?.categoryGroup;
};

export const getCategoryInfoFromAlias = (alias: string[]) => {
  const category = MYFC_CATEGORIES.find((category) =>
    alias?.includes(category)
  );
  const categoryGroup = category ? getCategoriesGroup(category) : '';
  const categoryIndex = MYFC_CATEGORIES.findIndex((category) =>
    alias?.includes(category)
  );
  return {category, categoryGroup, categoryIndex};
};

export const getCategoryId = (alias: string | string[]) => {
  const {category} = getCategoryInfoFromAlias(
    Array.isArray(alias) ? alias : [alias]
  );

  if (category) {
    return CATEGORY_ID[category as CATEGORIES];
  }
};

export const getCategoriesFrom = (group: CATEGORY_GROUP) => {
  return CATEGORY_GROUP_MAP[group] || [];
};
